import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

export default function Contact() {

  const {t} = useTranslation()

  return (
    <div className=' justify-center flex h-full'>

    <div className='bg-beige  m-5  mt-20 w-1/2 p-10 items-center  text-gray-900 font-sans rounded-lg text-center h-fit'>
    <h1 class="text-3xl font-bold mb-4 text-center">{t('contact.title')}</h1>
    <p class="mb-4">{t('contact.text')}</p>
                    <p class="mb-4 text-blue-800 text-xl font-bold text-center"><Link to={"mailto:support@att-app.com"}>
                    {t('contact.email')}
                    </Link></p>
 </div>
 </div>
  )
}
